import { render } from "./humanityFiveMuseum.vue?vue&type=template&id=1bc53d23&scoped=true"
import script from "./humanityFiveMuseum.vue?vue&type=script&lang=js"
export * from "./humanityFiveMuseum.vue?vue&type=script&lang=js"

import "./humanityFiveMuseum.vue?vue&type=style&index=0&id=1bc53d23&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc53d23"]])

export default __exports__